export const OPERATOR_TYPES = [
    {
        name: 'in',
        display_name: 'include',
        actual_type: 'filterOperators',
    },
    {
        name: 'not in',
        display_name: 'exclude',
        actual_type: 'filterOperators',
    },
];

export const DEFAULT_UI_FILTER = {
    field: {
        name: 'default',
        display_name: 'STATIC.PAGES.CUSTOM_DIMENSIONS.PLACEHOLDERS.FILTER_DIMENSION',
    },
    operator: {
        display_name: 'include',
        name: 'in',
        actual_type: 'filterOperators',
    },
    tags: [],
};

// Chart types
export const COLUMN_CHART = 'column';
export const BAR_CHART = 'bar';
export const STACKED_CHART = 'stacked';
export const LINE_CHART = 'line';
export const PIE_CHART = 'pie';

// Quick report only chart types
export const MULTI_CHART = 'multiChart';

export const CHART_TYPES = [
    { name: COLUMN_CHART, display_name: 'Bar Chart (Vertical)' },
    { name: BAR_CHART, display_name: 'Bar Chart (Horizontal)' },
    { name: STACKED_CHART, display_name: 'Stacked Bar Chart' },
    { name: LINE_CHART, display_name: 'Line Chart' },
    { name: PIE_CHART, display_name: 'Pie Chart' },
    { name: MULTI_CHART, display_name: 'Multi Chart' },
];

export const CUSTOM_DASHBOARD_CHART_TYPES = CHART_TYPES.filter(type =>
    [COLUMN_CHART, BAR_CHART, STACKED_CHART, LINE_CHART, PIE_CHART].includes(type.name)
);

export const WIDGET_TYPES = {};

CUSTOM_DASHBOARD_CHART_TYPES.forEach(x => {
    WIDGET_TYPES[x.name] = x.display_name;
});

export const WIDGET_TYPE_TOTALS = 'totals';

Object.assign(WIDGET_TYPES, {
    pivot: 'Pivot Table',
    table: 'Table',
    [WIDGET_TYPE_TOTALS]: 'Totals',
});

export const WIDGET_TYPE_OPTIONS = Object.keys(WIDGET_TYPES).map(k => ({ label: WIDGET_TYPES[k], value: k }));
